import { useEffect, useRef } from "react";
import invariant from "tiny-invariant";

/* @ts-expect-error untyped import */
import Checklist from "@editorjs/checklist";
import Code from "@editorjs/code";
import Delimiter from "@editorjs/delimiter";
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import Image from "@editorjs/image";
import InlineCode from "@editorjs/inline-code";
/* @ts-expect-error untyped import */
import LinkTool from "@editorjs/link";
import List from "@editorjs/list";
/* @ts-expect-error untyped import */
import Marker from "@editorjs/marker";
import Quote from "@editorjs/quote";
/* @ts-expect-error untyped import */
import SimpleImage from "@editorjs/simple-image";
import Table from "@editorjs/table";

/* eslint-disable */
// @ts-nocheck
import "./editor.css";

type UseEditorJsOptions = Partial<ConstructorParameters<typeof EditorJS>[0]>;

export const useEditorJs = (opts: UseEditorJsOptions) => {
  invariant(opts, "You must pass in options to useEditorJs");
  invariant(typeof opts === "object", "Options must be an object");

  const container = useRef<HTMLDivElement>(null);

  const editor = useRef<EditorJS>(null);

  const setupEditor = async () => {
    if (editor.current || !container.current) {
      return;
    }

    editor.current = new EditorJS({
      holder: container.current,
      data: opts.data,
      tools: {
        table: Table,
        /* @ts-expect-error ??? */
        header: {
          class: Header,
          config: {
            placeholder: "Enter a header",
          },
        },
        image: Image,
        list: List,
        checklist: Checklist,
        quote: Quote,
        code: Code,
        linkTool: LinkTool,
        delimiter: Delimiter,
        inlineCode: InlineCode,
        simpleImage: SimpleImage,
        marker: Marker,
      },
      inlineToolbar: true,
      placeholder: "Start typing here...",
      ...opts,
    });

    await editor.current.isReady;
  };

  useEffect(() => {
    if (editor.current) {
      return;
    }

    setupEditor();
  }, []);

  useEffect(() => {
    return () => {
      if (editor.current && typeof editor.current?.destroy === "function") {
        editor.current.destroy();
      }
    };
  }, []);

  const saveContent = async () => {
    if (!editor.current) {
      return;
    }

    const output = await editor.current.save();

    return output;
  };

  return {
    editorContainerRef: container,
    saveContent,
    editor: editor.current,
  };
};
